/**
 * Build the public HTTPS URL for a Finitless-hosted chat site (AI agent site object).
 * Mirrors logic used in AI Agents UI (WidgetConfigModal, AgentCard, AgentSitesSection).
 *
 * @param {{ domain?: string | null, temporal_domain?: string | null, ssl_status?: string | null } | null | undefined} site
 * @returns {string | null}
 */
export function getFinitlessChatSiteUrl(site) {
  if (!site) {
    return null;
  }

  if (site.domain && site.ssl_status === "issued") {
    return `https://${site.domain}`;
  }

  if (site.temporal_domain) {
    return `https://${site.temporal_domain}.finitless.ai`;
  }

  return null;
}

/**
 * Chat URL for a Finitless chat agent row from /ai/agents.
 *
 * @param {{ provider?: string | null, provider_type?: string | null, site?: object | null } | null | undefined} agent
 * @returns {string | null}
 */
export function getFinitlessAgentChatUrl(agent) {
  if (agent?.provider !== "finitless" || agent?.provider_type !== "chat") {
    return null;
  }

  return getFinitlessChatSiteUrl(agent.site);
}
